import {useIntl} from 'react-intl'
import {STORE_LOCATOR_MIN_ADDRESS_LENGTH} from '../../constants'

export default function useFindStoreFields({
    form: {
        control,
        formState: {errors}
    },
    prefix = ''
}) {
    const {formatMessage} = useIntl()

    const fields = {
        address: {
            name: `${prefix}address`,
            placeholder: formatMessage({
                defaultMessage: 'Your location',
                id: 'use_find_store_fields.placeholder.location'
            }),
            type: 'text',
            defaultValue: '',
            error: errors[`${prefix}address`],
            rules: {
                // a picked suggestion or GPS brings coordinates, typed text gets geocoded
                validate: (value, values) =>
                    Boolean(values[`${prefix}latitude`] && values[`${prefix}longitude`]) ||
                    (value || '').trim().length >= STORE_LOCATOR_MIN_ADDRESS_LENGTH ||
                    formatMessage(
                        {
                            defaultMessage:
                                'Please enter at least {count} characters or select an address from the suggestions.',
                            id: 'use_find_store_fields.error.address_too_short'
                        },
                        {count: STORE_LOCATOR_MIN_ADDRESS_LENGTH}
                    )
            },
            inputProps: {
                _placeholder: {color: 'stokkeCore.black'},
                autoComplete: 'street-address',
                'data-testid': 'input-address'
            },
            control
        },
        latitude: {
            name: `${prefix}latitude`,
            defaultValue: '',
            type: 'hidden',
            error: errors[`${prefix}latitude`],
            control
        },
        longitude: {
            name: `${prefix}longitude`,
            defaultValue: '',
            type: 'hidden',
            error: errors[`${prefix}longitude`],
            control
        }
    }

    return fields
}
